import { Separator } from "@porchpass/ui";
import { SlideUpModal } from "src/components/SlideUpModal";
import CalculationDetailsRow from "./MonthlyCalculationModal/CalculationDetailsRow";
import type { LoanOverviewFormData } from "src/api/adapters/application";

type CostBreakdownModalProps = {
  isOpen: boolean;
  loanOverviewFormData: LoanOverviewFormData;
  closeHandler: () => void;
};

export default ({
  isOpen,
  loanOverviewFormData,
  closeHandler,
}: CostBreakdownModalProps) => {
  return (
    <SlideUpModal
      hasIcon
      title="Total requested loan amount calculation"
      isOpen={isOpen}
      hasDismissButton={false}
      closeHandler={closeHandler}
      dismissible
      showCloseButton
    >
      <CalculationDetailsRow
        amount={loanOverviewFormData?.home_price ?? "0"}
        label={"Home Sale Price"}
        hasDollar
      />
      <CalculationDetailsRow
        amount={loanOverviewFormData?.home_upgrades_cost ?? "0"}
        label={"Home Upgrades"}
        hasDollar
      />
      <CalculationDetailsRow
        amount={loanOverviewFormData?.site_improvement_amount ?? "0"}
        label={"Site Improvements"}
        hasDollar
      />
      {loanOverviewFormData?.land_purchase_or_payoff_amount && (
        <CalculationDetailsRow
          amount={loanOverviewFormData?.land_purchase_or_payoff_amount ?? "0"}
          label={"Land Purchase Price/Payoff"}
          hasDollar
        />
      )}
      <CalculationDetailsRow
        amount={loanOverviewFormData?.down_payment_amount ?? "0"}
        label={"Down Payment"}
        hasDollar
      />
      <Separator className="my-4" />
      <CalculationDetailsRow
        amount={loanOverviewFormData?.loan_total_amount ?? "0"}
        label={"Total Home Price"}
        hasDollar
      />
      <br />
    </SlideUpModal>
  );
};
